import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoPedidoEstabDestinoService from '@/services/SistemaDKP/SLSTipoPedidoEstabDestino.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoPedidoEstabDestinoService = new SLSTipoPedidoEstabDestinoService();
  const refTipoPedidoEstabDestinoListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipopedidoid', label: 'Tipo Pedido', sortable: false },
    { key: 'estabelecimentoid', label: 'Estabelecimento', sortable: true },
    { key: 'ufiddestino', label: 'Destino', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTipoPedidoEstabDestino = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('tipopedidoid');
  const isSortDirDesc = ref(false);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoPedidoEstabDestinoListTable.value ? refTipoPedidoEstabDestinoListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoPedidoEstabDestino.value,
    };
  });

  const refetchData = () => {
    if (refTipoPedidoEstabDestinoListTable.value && typeof refTipoPedidoEstabDestinoListTable.value.refresh === 'function') {
      refTipoPedidoEstabDestinoListTable.value.refresh();
    } else {
      console.warn('refTipoPedidoEstabDestinoListTable não está inicializado ou não possui o método refresh.');
    }
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const create = async (body) => {
    try {
      await sLSTipoPedidoEstabDestinoService.store(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Destino cadastrado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Destino.', error);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Destino.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const Updated = async (body) => {
    const response = await sLSTipoPedidoEstabDestinoService.update(body);
    if (response) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Destino atualizado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Destino não foi atualizado.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
    refetchData();
  };

  const removerData = async (data) => {
    await sLSTipoPedidoEstabDestinoService.destroy(data);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    tableColumns,
    perPage,
    currentPage,
    totalTipoPedidoEstabDestino,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTipoPedidoEstabDestinoListTable,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    Updated,
    create,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
